export default __webpack_public_path__ + "static/media/armytokennft.2e518003.png";